<template>
  <CommonChip class="chip" :class="[chipClassName, { 'sc-chip--dark': value === 0 }]">
    <!-- TODO: remove '|| value' when we are sure that only proper marketingValues exist -->
    {{ marketingLabels[value] || value }}
  </CommonChip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { marketingLabels } from '@/bundles/Common/types/marketing';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default defineComponent({
  name: 'MarketingPushChip',

  components: { CommonChip },

  props: {
    value: {
      type: Number,
      required: true,
    }
  },

  computed: {
    chipClassName (): string {
      // TODO: remove this condition when we are sure that only proper marketingValues exist
      if (this.value < 0) {
        return 'bg-grey';
      }

      switch (this.value) {
        case 0: return 'bg-red';
        case 1: return 'bg-green-lighten-3';
        case 2: return 'bg-green text-white';
        default: return 'bg-green-darken-4 text-white';
      }
    },
    marketingLabels (): string[] {
      return marketingLabels;
    }
  }
});
</script>

<style lang="scss" scoped>
  .chip {
    min-width: 75px;
    justify-content: center;
    // The level is a `bg-*` class, so a change of value fades between the
    // two grounds instead of snapping.
    transition: background-color .3s, color .3s;
  }
</style>
